module.exports = __webpack_public_path__ + "img/prize-bg.0ce28bbb.png";